export default "__VITE_ASSET__Bzslouai__"